function SmallWidthWrapper({ children }) {
    return <div className="container">
        <div className="row">
            <div className="col-md-3" />
            <div className="col-md-6">
                {children}
            </div>
            <div className="col-md-3" />
        </div>
    </div>
}

export default SmallWidthWrapper;